import React from 'react';
import './BbBannerShared.css';

class Waiting extends React.Component {
  componentDidMount()
  {
    const rooot = document.getElementById('root');
    rooot.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  render() {
    console.log('*** WAITING ***');
    if (parseInt(this.props.thisUser, 10) === parseInt(this.props.gameroomDriver, 10))
    {
      return (
        <div className="container-fluid bg-secondary">
          <div className="row g-0">
            <div className="col center">
              <div id="#waiting" className="banner_shared">
                <h5>
                  You join the game, in a few seconds, when the next question
                  loads.
                </h5>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="container-fluid bg-secondary">
        <div className="row g-0">
          <div className="col center">
            <div id="#waiting" className="banner_shared">
              <h5>
                You join the game, in a few seconds, when the next question
                loads.
              </h5>
              <p className="waiting_on_cat">
                If you are in a private game room, you&apos;ll wait for the room&apos;s
                organizer to select a game category.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Waiting;
